import React, { forwardRef } from "react";
import { Col, Card, Spinner } from "react-bootstrap";
import { motion } from "framer-motion";

// English box. Backward compatible: old callers pass props.last.lastData;
// new stats pages pass props.last.{loading|noData|value}.
const StaticCovidDataItem_En = forwardRef((props, ref) => {
  const L = props.last;

  let content;
  if (L.loading) {
    content = <Spinner size="sm" animation="border" variant="info" />;
  } else if (L.noData) {
    content = <h3 className="text-danger" style={{ fontSize: "1.15rem" }}>no data</h3>;
  } else if (L.value !== undefined) {
    content = <h3>{L.value}</h3>;
  } else {
    content = L.lastData ? (
      isNaN(L.lastData) ? <p className="text-danger">no data available</p> : <h3>{L.lastData}</h3>
    ) : (
      <Spinner style={{ position: "absolute", top: "10%" }} size="sm" animation="border" variant="info" />
    );
  }

  return (
    <Col xs={12} md={4} ref={ref}>
      <Card border="light" style={({ width: "5rem" }, { height: "8rem" })} className="mx-2 my-2 shadow1">
        <Card.Body>
          <Card.Title className="text-center text-info">{content}</Card.Title>
          <Card.Text className="text-center">
            <small>{L.name}</small>
          </Card.Text>
        </Card.Body>
        <Card.Footer className="bg-white shadow1 mx-3 " style={{ width: "12rem" }}>
          <small className="text-muted">
            <small className="text-center">As of {L.lastDatadate ? L.lastDatadate : <div></div>}</small>
          </small>
        </Card.Footer>
      </Card>
    </Col>
  );
});

const MSCDItem = motion(StaticCovidDataItem_En);
export default MSCDItem;
export { StaticCovidDataItem_En };
